import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-complaint-types',
  templateUrl: './complaint-types.component.html',
  styleUrls: ['./complaint-types.component.scss']
})
export class ComplaintTypesComponent {
}
